export const USER_NOTIFICATION_TYPES = [
  "WELCOME_FIRST_LOGIN",
  "WELCOME_RETURNING",
  "REQUEST_RECEIVED",
  "VERIFICATION_APPROVED",
  "VERIFICATION_REJECTED",
  "DISCOVERY_UNLOCKED",
  "REQUEST_DECLINED",
  "REQUEST_ACCEPTED",
  "SENDER_PAYMENT_REQUIRED",
  "SENDER_PAYMENT_FINAL_REMINDER",
  "PARTNER_PAYMENT",
  "CREDITS_RESTORED_TIMEOUT",
  "FREE_CREDITS_EXPIRING_SOON",
  "FREE_CREDITS_EXPIRED",
  "WORKSPACE_UNLOCKED",
  "CHAT_MESSAGE",
  "DOCUMENT_SHARED",
  "PREFERRED_PARTNER_RECOMMENDED",
  "FACILITATOR_ASSIGNMENT_REQUEST_RECEIVED",
  "FACILITATOR_ASSIGNMENT_ACCEPTED",
  "FACILITATOR_ASSIGNMENT_REJECTED",
  "FACILITATOR_PARTNER_RECOMMENDED",
  "ECOSYSTEM_HEAD_JOIN_REQUEST",
  "ECOSYSTEM_HEAD_JOIN_ACCEPTED",
  "ECOSYSTEM_HEAD_JOIN_REJECTED",
  "ECOSYSTEM_HEAD_QUESTIONNAIRE_SUBMITTED",
  "ECOSYSTEM_HEAD_MORE_INFO_SUBMITTED",
  "ECOSYSTEM_HEAD_VERIFICATION_APPROVED",
  "ECOSYSTEM_HEAD_VERIFICATION_REJECTED",
  "ECOSYSTEM_HEAD_COMPANY_REMOVED",
  "ECOSYSTEM_HEAD_MORE_INFO_REQUESTED",
  "ECOSYSTEM_HEAD_PARTNER_RECOMMENDED",
  "ECOSYSTEM_HEAD_COLLAB_REVIEW_RECEIVED",
  "ECOSYSTEM_HEAD_COLLAB_REVIEW_QUEUED",
  "ECOSYSTEM_HEAD_COLLAB_REVIEW_REJECTED",
  "ECOSYSTEM_HEAD_COLLAB_REVIEW_FORWARDED",
  "ECOSYSTEM_HEAD_MEETING_SCHEDULED",
  "ECOSYSTEM_HEAD_MEETING_CANCELLED",
  "ECOSYSTEM_HEAD_MEETING_RESCHEDULED",
  "ADMIN_ECOSYSTEM_HEAD_RECOMMENDED",
  "ADMIN_EXPERT_RECOMMENDED",
  "ADMIN_FACILITATOR_COMPANY_RECOMMENDED",
  "EXPERT_JOIN_REQUEST",
  "EXPERT_JOIN_ACCEPTED",
  "EXPERT_JOIN_REJECTED",
  "EXPERT_OFFER_RECEIVED",
  "EXPERT_OFFER_ACCEPTED",
  "EXPERT_OFFER_REJECTED",
  "EXPERT_QUESTIONNAIRE_SUBMITTED",
  "EXPERT_MORE_INFO_SUBMITTED",
  "EXPERT_VERIFICATION_APPROVED",
  "EXPERT_VERIFICATION_REJECTED",
  "EXPERT_MORE_INFO_REQUESTED",
  "EXPERT_PARTNER_RECOMMENDED",
  "EXPO_MEMBER_ADDED",
  "EXPO_JOIN_ACCEPTED",
  "EXPO_JOIN_REJECTED",
  "EXPO_EVENT_PUBLISHED",
  "EXPO_COMPANY_REACHOUT",
] as const;

export type UserNotificationType = (typeof USER_NOTIFICATION_TYPES)[number];

export type NotificationListFilter = "unread" | "read";

export type UserNotificationDto = {
  id: string;
  userId: string;
  type: UserNotificationType;
  title: string;
  body: string;
  actionUrl: string | null;
  readAt: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
};

export const USER_NOTIFY_SOCKET_EVENT = "user_notify:event" as const;

export function userNotificationRoom(userId: string): string {
  return `user_notify:${userId}`;
}
